/**
 * JCTCTAS-152: standalone Vite entry combining modules/recommended-glow-
 * canvas.js and modules/recommended-glow-viewport.js -- split out of
 * common.js together since they drive the exact same ambient "recommended"
 * highlight ring (see components/_event-card-recommended-glow.scss's own
 * doc comment).
 *
 * Gated by inc/scripts.php's jctc_recommended_glow_script() on TWO blocks
 * (jctc/upcoming-events, jctc/all-events), not Recommended Events despite
 * this entry's own filename -- both modules' own selectors target
 * `.events-grid` (Upcoming Events) and `.all-events-block` (All Events)
 * only. Recommended Events deliberately has no glow ring at all (product
 * decision -- every card there is already Recommended by definition, so
 * the same ring would have nothing left to contrast against); see
 * blocks/recommended-events/render.php's own doc comment. See
 * entries/hero-video-viewport.js's own doc comment for why no
 * `$(document).ready()` wrapper is needed.
 */
import initRecommendedGlowCanvas from '../modules/recommended-glow-canvas.js';
import initRecommendedGlowViewport from '../modules/recommended-glow-viewport.js';

document.addEventListener('DOMContentLoaded', () => {
    initRecommendedGlowCanvas();
    initRecommendedGlowViewport();
});
